import React from 'react';
import enhance from './enhance';
import styles from './styles.module.scss';

const MiniAlternativeDesign = ({ design, onClick, optionStyles }) => (
  <div className={styles.alternativeDesign}>
    <img
      onClick={onClick}
      onTouchStart={onClick}
      className={optionStyles}
      alt={design.id}
      src={design.iconImgUrl}
    />
    <span>
      {design.id} - {design.description} $({design.upcharge})
    </span>
  </div>
);

export default enhance(MiniAlternativeDesign);
